module.exports = __webpack_public_path__ + "img/govtjobs.8cfb50b3.svg";